import React from "react";
import ConfigEditor from "./ConfigEditor";

const DeviceAlertConfigEditorWrapper = () => {
  return <ConfigEditor mode="device" />;
};

export default DeviceAlertConfigEditorWrapper;
